<div class="flex pt-2" appManageValidatorDisplay [control]="formControl">
  @if (props.keyFilter) {
    <cap-input
      [formControl]="formControl"
      [label]="props.label"
      [disabled]="!props.is_editable"
      [hasTooltip]="props.tooltip"
      [autofocus]="props.autofocus"
      [placeholder]="props.placeholder"
      [filter]="props.keyFilter">
      <app-form-tooltip [text]="props.tooltip" class="tooltip-content"></app-form-tooltip>
    </cap-input>
  } @else {
    <cap-input
      [formControl]="formControl"
      [label]="props.label"
      [disabled]="!props.is_editable"
      [autofocus]="props.autofocus"
      [hasTooltip]="props.tooltip"
      [placeholder]="props.placeholder">
      <app-form-tooltip [text]="props.tooltip" class="tooltip-content"></app-form-tooltip>
    </cap-input>
  }
</div>
